import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import {
  IsUUID,
  IsOptional,
  IsString,
  IsArray,
  IsNumber,
} from 'class-validator';

/**
 * Classe de base pour les DTOs liés à l'IA
 * Contient tous les champs communs partagés entre generate, preview et approve
 */
export class BaseActivityAIDto {
  @ApiProperty({
    description: "ID du type d'activité",
    example: '123e4567-e89b-12d3-a456-426614174001',
  })
  @IsUUID()
  typeId!: string;

  @ApiProperty({
    description: 'IDs des leçons (le contexte sera construit automatiquement)',
    example: ['123e4567-e89b-12d3-a456-426614174001'],
  })
  @IsArray()
  @IsUUID(undefined, { each: true })
  lessonIds!: string[];

  @ApiPropertyOptional({
    description: "Titre de l'activité",
    example: 'Les fractions - Exercice pratique',
    type: 'string',
  })
  @IsOptional()
  @IsString()
  title?: string;

  @ApiPropertyOptional({
    description: "Description de l'activité",
    example: 'Complétez les exercices suivants sur les fractions',
    type: 'string',
  })
  @IsOptional()
  @IsString()
  description?: string;

  @ApiPropertyOptional({
    description: "Durée de l'activité (en minutes)",
    example: 15,
  })
  @IsOptional()
  @IsNumber()
  duration?: number;

  @ApiPropertyOptional({
    description: 'Langue de génération',
    example: 'fr',
    default: 'fr',
  })
  @IsOptional()
  @IsString()
  language?: string;

  @ApiPropertyOptional({
    description: 'Liste des IDs des ressources à utiliser',
    example: [
      'c341dd2d-f900-49b1-b0f0-cbb9b7833e51',
      'c341dd2d-f900-49b1-b0f0-cbb9b7833e52',
    ],
  })
  @IsOptional()
  @IsArray()
  @IsUUID(undefined, { each: true })
  resourcesIds?: string[];

  @ApiPropertyOptional({
    description: "Instructions personnalisées pour l'IA",
    example:
      'Créer une activité adaptée aux élèves de 6ème avec des exemples concrets',
    type: 'string',
  })
  @IsOptional()
  @IsString()
  customInstructions?: string;
}
